import {
  AgeRange,
  Audience,
  AudienceGender,
} from '../redux-toolkits/shared/shared.type'

const audienceGenders: AudienceGender[] = ['MALE', 'FEMALE']

const isAudienceGender = (gender: string): gender is AudienceGender =>
  audienceGenders.includes(gender as AudienceGender)

const toAgeRangePayload = (ageRange?: AgeRange | null): AgeRange | null =>
  ageRange?.min === undefined && ageRange?.max === undefined
    ? null
    : ageRange ?? null

export const toAudiencePayload = ({
  ageRange,
  genders = [],
}: {
  ageRange?: AgeRange | null
  genders?: string[]
}): Required<Audience> => ({
  ageRange: toAgeRangePayload(ageRange),
  genders: genders.filter(isAudienceGender),
})
